// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"0":"b1f4c4cd","704":"3c2cfd18"}[chunkId] + ".js";
};